<template>
  <div class="online-course">
    <div v-for="(item, index) in dataList" :key="index">
      <p v-if="item.path" class="tit">{{ item.path }}</p>
      <div class="parent-list" v-for="(dta, idx) in item.list" :key="idx" @click="getChild(dta)">
        <div class="parent">
          <div v-if="dta.type == 99" class="self_class">
            <p class="self_title"><span class="self_tag">自助开课</span><span class="title-msg">{{ dta.name }}</span></p>
            <div class="time_limit"><p><span v-show="dta.show_time">{{ dta.expired }}</span></p><p class="expired" @click="go_selfclass(dta.coding)">请根据需要，选择课程<span>去开课</span></p></div>
          </div>
          <div v-else>
            <p>
              <img src="../../../static/images/arrow-down.png" alt v-if="dta.isShow" />
              <img src="../../../static/images/arrow-right.png" alt v-else />
            </p>
            <div class="title-msg">
              <p>{{ dta.name }}</p>
              <p class="expired">{{ dta.expired }}</p>
            </div>
          </div>
          <div v-if="dta.isShow">
            <div class="child-list" v-for="(data, id) in dta.list" :key="id">
              <div class="child" @click.stop="getComponents(data.id, data, dta.coding)">
                <div style="display:flex">
                  <p>
                    <img src="../../../static/images/arrow-right.png" alt v-if="!data.isShow" />
                    <img src="../../../static/images/arrow-down.png" alt v-else />
                  </p>
                  <div class="title-msg">
                    <p>{{ data.name }}</p>
                    <p class="expired">{{ data.level_count }}个课件 <span class="placeline"></span> {{ data.hour }}课时</p>
                  </div>
                </div>
                <div class="components" v-for="(i, index) in componentsList" :key="index">
                  <div v-if="data.isShow">
                    <div class="components-list" v-if="data.id == i.id">
                      <div v-for="(lst, listdx) in i.list" :key="listdx">
                        <p class="level_title" v-if="lst.children != ''">{{ lst.title }}</p>
                        <div v-for="(item, dx) in lst.children" :key="dx">
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="item.module_type == 1 || (item.module_type == 19 && item.type == 3)"
                          >
                            <p>
                              <img src="../../../static/images/doc.png" class="doc" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg"><span>文档</span> <span class="placeline"></span> {{ item.file_size }}M</p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="item.module_type == 2 || (item.module_type == 19 && item.type == 2)"
                          >
                            <p>
                              <img src="../../../static/images/video.png" class="video" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">
                                视频
                                <span
                                  v-if="item.video_time"
                                ><span class="placeline"></span> {{ item.video_time | formatSeconds }}</span>
                              </p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item)"
                            v-if="item.module_type == 4 || (item.module_type == 19 && item.type == 8)"
                          >
                            <p>
                              <img src="../../../static/images/write.png" class="write" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">试卷</p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item)"
                            v-if="item.module_type == 5 || (item.module_type == 19 && item.type == 4)"
                          >
                            <p>
                              <img src="../../../static/images/write.png" class="write" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">练习</p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="
                              item.module_type == 6 && item.is_playback == 1
                            "
                          >
                            <p>
                              <img src="../../../static/images/playback.png" class="video" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">
                                回放 <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} -
                                {{ item.end_time | localDateH }}</span>
                              </p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-else-if="item.module_type == 6 || (item.module_type == 19 && item.type == 6)"
                          >
                            <p>
                              <img src="../../../static/images/zhibo.png" class="write" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">
                                直播 <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} -
                                {{ item.end_time | localDateH }}</span>
                              </p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="item.module_type == 7 || (item.module_type == 19 && item.type == 7)"
                          >
                            <p>
                              <img src="../../../static/images/handout.png" class="handout" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">讲义夹</p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item)"
                            v-if="item.module_type == 9"
                          >
                            <p>
                              <img src="../../../static/images/zhibo.png" class="write" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">
                                直播 <span v-if="(goodsType != 6 && goodsType != 10) || item.is_show_time"><span class="placeline"></span> {{ item.start_time | timeFormat }} -
                                {{ item.end_time | localDateH }}</span>
                              </p>
                            </div>
                          </div>
                           <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="item.module_type == 19 && (item.type == 0 || item.type == 1)"
                          >
                            <p>
                              <img src="../../../static/images/doc.png" class="doc" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg"><span>作业</span> <span class="placeline"></span> {{ item.file_size }}M</p>
                            </div>
                          </div>
                          <div
                            class="com-child"
                            @click.stop="judgetype(item, dta.coding)"
                            v-if="item.module_type == 20 || (item.module_type == 19 && item.type == 20)"
                          >
                            <p>
                              <img src="../../../static/images/dryRun.png" class="handout" alt />
                            </p>
                            <div>
                              <p class="title">{{ item.name }}</p>
                              <p class="other-msg">模考</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="handout_assembly" v-show="handout_flag" @click.stop="parent">
                <handoutFile @child="parent" :files="handoutlist" :cid='handoutcid' :packageid='handoutpack' class="handout_content"></handoutFile>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popup :data='detail' :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <div class="class_dialog" v-if="zujian_flag">
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}APP"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href=scheme @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp"><a @click="search_flag">去APP查看</a></span>
        </p>
      </div>
    </div>
    <goapp @openapp='goapp' v-if="zujians_flag" :data='detail'></goapp>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import formatSeconds from "../../utils/formatSecond.js";
import timeFormat from "../../utils/timeFormat.js";
import localDateH from "../../utils/localDate.js";
import handoutFile from "../handout/index"; //讲义
import goapp from "../popup/goapp" //打开APP
import popup from "../popup/index" //小程序弹窗
import { Toast } from "vant";
import arouse from '../arouse/index.vue'
import "vant/lib/toast/style";

export default {
  data() {
    return {
      isDefault: true, //层级是否默认收起状态
      isShowChild: false,
      ticket: JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
      ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      iip_list: [],
      handout_flag: false,
      handoutlist: [],
      handoutcid: '',
      handoutpack: '',
      package_id: "",
      componentsList: [],
      zujian_flag: false,
      zujians_flag: false,
      detail: '',
      shopid: '',
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      applets_flag: false,
      sf: '',
      appname: '',
      open_url: '',
      sso_id: localStorage.getItem("ticketObj")?JSON.parse(localStorage.getItem("ticketObj")).sso_id:'',
      sn: this.$route.query.order_id,
      scheme: '',
      arshow: false,
      isweixin: false,
      goodsType: ''
    };
  },
  props: ["dataList",'currentIndex'],
  components: {
    handoutFile,
    Toast,
    popup,
    goapp,
    arouse
  },
  filters: {
    formatSeconds: function (value) {
      return formatSeconds(value);
    },
    timeFormat: function (value) {
      return timeFormat(value);
    },
    localDateH: function (value) {
      return localDateH(value);
    },
  },
  mounted () {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    this.getDetail()
    this.sf = this.$route.query.sf
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.scheme = 'shiyedanwei://'
      this.open_url = 'http://3min-class.offcn.com/videos/h5/download/institution/'
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
      this.scheme = 'zhonggongtiku://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
    } else if (this.sf == 'zgzsb') {
      this.appid = 'wx9487d9bc65834b47'
      this.appname = '中公专升本'
      this.scheme = 'zhonggongzhuanshengben://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
    } else if (this.sf == 'zgyljy'){
      this.appid = 'wxc7238886c470203e'
      this.appname = '中公医疗教育'
      this.scheme = 'zhonggongyiliaojiaoyu://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_yikao'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
      this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
    } else if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      if (this.sf == 'sydw') {
        window.location.href ="https://xue.offcn.com/institution/";
      } else if (this.sf == 'zgwx') {
        window.location.href ="https://www.eoffcn.com/help/download/online_course.html";
      } else if (this.sf == 'zgzsb') {
        window.location.href ="https://www.offcnzsb.com/zg/scan/";
      } else {
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    getDetail () {
      this.$api.GETDETAIL({
        system_order_num: this.$route.query.order_id,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          this.shopid = res.data.goodsId
          this.goodsType = res.data.goodsType
        } else if (res.code == 2 || res.code == 4) {
          sso.goAuth()
        }
      })
    },
    getChild(data) {
      let flag = !data.isShow;
      this.$set(data, "isShow", flag);
      this.isDefault = !this.isDefault;
    },
    getComponents(id, data, cid) {
      data.isShow = !data.isShow;
      this.package_id = id;
      this.$api
        .GETCATALOG({
          system_order_num: this.$route.query.order_id,
          package_id: id,
          coding: cid,
          "offcn-ticket": this.ticket,
          ticket_source: this.ticket_source,
        })
        .then((res) => {
          if (res.code == 0) {
            if (this.componentsList.length > 0) {
              this.componentsList.forEach((item, index) => {
                if (item.id == id) {
                  // console.log(id);
                  return;
                } else {
                  this.componentsList.push({
                    id: id,
                    list: res.data.catalog.list,
                  });
                }
              });
            } else {
              this.componentsList.push({ id: id, list: res.data.catalog.list });
            }
            this.componentsList = this.uniqueArr(this.componentsList);
          } else if (res.code == 2 || res.code == 4) {
            sso.goAuth()
          }
        })
        .catch(() => {});
    },
    uniqueArr(arr) {
      //对象数组去重
      const newArr = new Map();
      return arr.filter((arr) => !newArr.has(arr.id) && newArr.set(arr.id, 1));
    },
    judgetype(item, cid) {
      if (item.module_type == 1 || (item.module_type == 19 && (item.type == 0 || item.type == 1 || item.type == 3))) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          this.$router.push({
            path: "/file",
            query: {
              order_id: this.$route.query.order_id,
              package_id: this.package_id,
              cid: cid,
              unit_id: item.menu_id,
              module_type: item.module_type,
              url: item.url
            }
          });
        }
      } else if (item.module_type == 2 || (item.module_type == 19 && item.type == 2)) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          this.$router.push({
            path: "/video",
            query: {
              order_id: this.$route.query.order_id,
              package_id: this.package_id,
              cid: cid,
              media_id: item.video_id,
              name: item.name,
              time: item.video_time,
              id: item.menu_id,
              video_source: item.video_source,
              owner: this.$route.query.owner,
              channel: this.$route.query.channel,
              orgn: this.$route.query.orgn
            }
          });
        }
      } else if (item.module_type == 4 || item.module_type == 5 || item.module_type == 20 || (item.module_type == 19 && (item.type == 4 || item.type == 8 || item.type == 20))) {
        if (this.isapplets) {
            this.applets_flag = true
        } else {
          this.zujian_flag = true
          this.$nextTick(() => {
            var btn = document.getElementById('launch-btn')
            btn.addEventListener('launch', function(e) {
              this.handleJudgeWechat(); //是否满足跳转app条件
            });
          })
        }
      } else if (item.module_type == 6 && item.operator == 2) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          let time = parseInt(new Date().getTime() / 1000);
          let url
          if (item.is_playback == 1) {
            url = item.playback_url.replace('http:', '')
          } else {
            url = item.live_url.replace('http:', '')
          }
          if (time > item.end_time + 3600 && item.is_playback != 1) {
            Toast("直播已结束");
          } else if (time < item.start_time - 3600) {
            Toast("直播未开始");
          } else {
            location.href = url
            // this.$router.push({
            //   path: "/livevod",
            //   query: {
            //     order_id: item.system_order,
            //     package_id: this.package_id,
            //     cid: cid,
            //     unit_id: item.menu_id,
            //     module_type: 6,
            //     url: url
            //   }
            // })
          }
        }
      } else if (item.module_type == 6 || (item.module_type == 19 && item.type == 6)) {
        if (item.learning_style.indexOf(2) == -1) {
          this.detail = item
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.package_id
          this.detail.cid = cid
          this.detail.shopid = this.shopid
          if (this.isapplets) {
            this.applets_flag = true
          } else {
            this.zujians_flag = true
          }
        } else {
          let time = parseInt(new Date().getTime() / 1000);
          if (time > item.end_time + 3600 && item.is_playback != 1) {
            Toast("直播已结束");
          } else if (time < item.start_time - 3600) {
            Toast("直播未开始");
          } else if (item.is_playback == 1) {
            this.$router.push({
              path: "/livevod",
              query: {
                order_id: this.$route.query.order_id,
                package_id: this.package_id,
                cid: cid,
                unit_id: item.menu_id,
                live_type: 3,
                module_type: 66,
                url: item.live_record_url
              }
            })
          } else {
            this.$router.push({
              path: "/livevod",
              query: {
                order_id: this.$route.query.order_id,
                package_id: this.package_id,
                cid: cid,
                unit_id: item.menu_id,
                module_type: 6,
                url: item.live_record_url
              }
            })
          }
        }
      } else if (item.module_type == 7 || (item.module_type == 19 && item.type == 7)) {
        this.handout_flag = true;
        this.handoutlist = item;
        this.handoutcid = cid
        this.handoutpack = this.package_id
      } else if (item.module_type == 9) {
        if (this.isapplets) {
          this.applets_flag = true
        } else {
          this.zujian_flag = true
          this.$nextTick(() => {
            var btn = document.getElementById('launch-btn')
            btn.addEventListener('launch', function(e) {
              this.handleJudgeWechat(); //是否满足跳转app条件
            });
          })
        }
      }
    },
    parent() {
      this.handout_flag = false;
    },
    popup() {
      this.applets_flag = false;
    },
    goapp () {
      this.zujians_flag = false;
    },
    cancel_flag() {
      this.zujian_flag = false
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          location.href = 'https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgtk') {
          location.href = 'https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'sydw') {
          location.href = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgzsb') {
          location.href = 'https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgyljy') {
          location.href = 'https://www.eoffcn.com/zg_yikao/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgky') {
          location.href = 'https://www.eoffcn.com/zg_postgraduate/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgjsgc') {
          this.openApp('https://www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    },
    go_selfclass (item) {
      this.$router.push({
        path: "/selfService",
        query: { order_id: this.$route.query.order_id, coding: item }
      });
    }
  },
  created(){
    localStorage.setItem('currentIndex',this.currentIndex);
  }
};
</script>
<style lang="less" scoped>
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
  opacity: 0;
}
.online-course {
  width: 100%;
  .tit {
    color: #333333;
    font-size: 20px;
    padding: 18px 30px;
    line-height: 1.3;
    background: #f6f6f6;
  }
  .parent-list {
    width: 100%;
    background: #fff;
    padding: 30px 0 30px 30px;
    border-bottom: 1px solid #e6e6e6;
    .parent {
      display: flex;
      flex-direction: column;
      > div:first-child {
        display: flex;
      }
      .self_class {
        flex-direction: column;
        padding: 0 30px 0 46px;
        .time_limit {
          display: flex;
          justify-content: space-between;
          color: #999999;
          margin-top: 14px;
        }
        .expired {
          position: relative;
          width: 350px;
          height: 34px;
          font-size: 24px;
          background: #f5f5f5;
          border-radius: 18px;
          padding-left: 16px;
          span {
            position: absolute;
            right: 0;
            width: 90px;
            text-align: center;
            border-radius: 18px;
            color: #ffffff;
            background: linear-gradient(90deg, #d75b4a 0%, #d33f3a 100%), linear-gradient(#ed8a8f, #ed8a8f);
          }
        }
      }
      .self_title {
        display: flex;
        align-items: center;
      }
      .self_tag {
        display: inline-block;
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 32px;
        color: #e60012;
        font-size: 20px;
        background: #fce5e7;
        border-radius: 8px;
        margin-right: 10px;
      }
    }
    .child-list {
      padding-left: 30px;
      border-top: 1px solid #e6e6e6;
      margin-top: 30px;
      padding-top: 30px;
      .child {
        display: flex;
        flex-direction: column;
      }
    }
    img {
      width: 30px;
      height: 30px;
      margin-right: 15px;
      margin-top: 6px;
      &.video {
        width: 44px;
        height: 42px;
      }
      &.write {
        width: 43px;
        height: 44px;
      }
      &.doc {
        width: 45px;
        height: 49px;
      }
      &.handout {
        width: 46px;
        height: 45px;
      }
    }
    .title-msg {
      font-size: 30px;
      color: #333;
      font-weight: bold;
      align-items: center;
      .expired {
        font-size: 22px;
        color: #999;
        margin-top: 8px;
        font-weight: normal;
        display: flex;
        align-items: center;
      }
    }
    .components {
      background: #fff;
      .components-list {
        margin-top: 30px;
        .level_title {
          margin-top: 20px;
          font-weight: bold;
        }
        .com-child {
          display: flex;
          align-items: center;
          margin-top: 40px;
        }
        .title {
          font-size: 28px;
          color: #333;
        }
        .other-msg {
          color: #999;
          font-size: 20px;
          margin-top: 10px;
          display: flex;
          align-items: center;
        }
        .practice {
          margin-top: 30px;
          display: flex;
          align-items: center;
          padding-left: 15px;
        }
      }
    }
    .tag {
      font-size: 18px;
      color: #808080;
      padding: 7px 11px;
      background-color: #f0f0f0;
      border-radius: 8px;
      margin-left: 13px;
    }
  }
}
.handout_assembly {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  .handout_content {
    position: absolute;
    top: 30%;
    overflow: auto;
  }
}
.popop_content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right:0;
  z-index: 2;
}
.class_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 2;
  .dialog_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    line-height: 40px;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    background: #fff;
    .dialog_message {
      text-align: center;
      padding: 30px 30px;
    }
    p {
      display: flex;
      border-top: 1px solid #e5e5e5;
      height: 70px;
      line-height: 70px;
      span {
        flex: 1;
        text-align: center;
      }
      .goapp {
        color: #e60012;
        border-left: 1px solid #e5e5e5;
        a {
          color: #e60012;
        }
      }
    }
  }
}
.placeline{
  width: 1px;
  height: 26px;
  background: #999999;
  display: inline-block;
  margin: 0 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/onlineCourse.vue